import { App } from './app';
import { CatalogStore } from './catalog/CatalogStore';
import './styles.css';

const host = document.getElementById('app');
if (!host) throw new Error('Missing #app');

const store = new CatalogStore();
await store.load();
await store.seedIfNeeded();
new App(host, store);
